import React, { useState, useEffect, useRef, useMemo } from "react";
import Chart from "chart.js/auto";
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import "../css/summary.css";
import axios from "axios";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { backend_url } from "../App.js";
import { useNavigate } from "react-router-dom";

Chart.register(ChartDataLabels);
//import ChartDataLabels from 'chartjs-plugin-labels';

function Summary() {
    //Finance bar DOM container
    let live_barRef = useRef(null);
    let owe_barRef = useRef(null);
    let give_barRef = useRef(null);
    let grow_barRef = useRef(null);

    //Finance bar <h2> text container DOM refs
    let live_sumRef = useRef(null);
    let give_sumRef = useRef(null);
    let grow_sumRef = useRef(null);
    let owe_sumRef = useRef(null);

    //Variables for the summary finance bar values
    let [live_sum, setLiveSum] = useState(parseFloat(sessionStorage.getItem("liveTotal") || 0));
    let [give_sum, setGiveSum] = useState(parseFloat(sessionStorage.getItem("giveTotal") || 0));
    let [grow_sum, setGrowSum] = useState(parseFloat(sessionStorage.getItem("growTotal") || 0));
    let [owe_sum, setOweSum] = useState(parseFloat(sessionStorage.getItem("oweTotal") || 0));

    //Progress bar DOM Refs
    let circularProgressRef = useRef(null);
    let progressValueRef = useRef(null);
    let income_inputRef = useRef(null);
    let after_tax_divRef = useRef(null);
    let [afterTaxNum, setAfterTaxNum] = useState(parseFloat(sessionStorage.getItem("after_tax_num") || 0));
    let [incomeValue, setIncomeValue] = useState(parseFloat(sessionStorage.getItem("income_value")) || '');
    let [incomeExists, setIncomeExists] = useState(parseInt(sessionStorage.getItem("incomeExists") || 0));

    // Pie Chart viewport Ref
    const pieViewportRef = useRef(null);

    /** Links to expenses page when bars are clicked ***/
    useEffect(() => {
        live_barRef.current.addEventListener('click', () => {
            window.location.href = "/expenses#form-header";
        });

        give_barRef.current.addEventListener('click', () => {
            window.location.href = "/expenses#form-header";
        });

        grow_barRef.current.addEventListener('click', () => {
            window.location.href = "/expenses#form-header";
        });

        owe_barRef.current.addEventListener('click', () => {
            window.location.href = "/expenses#form-header";
        });
    }, [live_barRef, give_barRef, grow_barRef, owe_barRef]);

    // Update page session values on refresh
    let updateSession = () => {   
        animateBar();
    };

    useEffect(() => {
        updateSession();
    }, []);

    let handleIncomeInputFocus = () => {
        income_inputRef.current.value = incomeValue;
    };

    let handleCurrencyKeyPress = (event) => {
        // Stop from entering multiple periods
        if (event.charCode === 46) {
            if (event.target.value.indexOf('.') !== -1) {
                event.preventDefault();
            }
        } 
        // Check for enter key, allow submission of form if it is
        else if (event.charCode !== 13) { 
            // Check for number only input
            if ((event.charCode > 31) && (event.charCode < 48 || event.charCode > 57)) {
                event.preventDefault();
            }
            // Check for only two decimal places
            let searchVal = event.target.value.search(/\./);
            if (searchVal !== -1 && event.target.selectionStart > searchVal && event.target.value.split('.')[1].length === 2) {
                event.preventDefault();
            }
        }
    };

    // Esnures the value is valid
    let validateValue = (amnt) => {
        let regX = /[^0-9.]/g;
        amnt = String(amnt);

        if (amnt.trim().search(regX) !== -1){
            amnt = amnt.replace(regX, "");
            if (amnt.search(/\d+/g) === -1)
            {
                amnt = 0;
            }
        }
        return amnt;
    }

    // Creates a new summary total for a user that hasn't entered any expenses yet
    let createMongoTotal = async (uid, incomeVal) => {
        try {
            //send post request to the 'api/users' endpoint
            const response = await axios.post(backend_url + 'summary', { 
                userID: uid,
                financeTotal: incomeVal,
                type: 'incomeTotal',
            });
            sessionStorage.setItem("income_value", incomeVal);


        } catch (error) {
            console.error(error);
        }

    } 

    // Updates the summary to reflect any changes made in the table
    let updateMongoTotal = async (uid, incomeVal, ty) => {
        try {
            const response = await axios.post(backend_url + 'updateSummary', { 
                userID: uid,
                financeTotal: incomeVal,
                type: ty,
            });
            sessionStorage.setItem("income_value", incomeVal);
        } catch (error) {
            console.error(error);
        }

    }

    // Sets the incomeValues
    let handleIncomeFocusOut = async () => {
        incomeValue = validateValue(incomeValue);

        if (incomeValue !== '')
        {            
            // If it doesn't equal 0, set it an update the total
            if (incomeExists !== 0){
                setIncomeValue(incomeValue);
                updateMongoTotal(sessionStorage.getItem('userID'), incomeValue, 'incomeTotal');

            }
            // If it does, create a new total
            else {
                createMongoTotal(sessionStorage.getItem('userID'), incomeValue);
                setIncomeExists(1);
                sessionStorage.setItem('incomeExists', 1);
            }           
              
            animateBar();
            income_inputRef.current.value = '$' + parseFloat(incomeValue).toLocaleString('en-US', {'minimumFractionDigits':2,'maximumFractionDigits':2});
        }
        else {
            setIncomeValue('');
            sessionStorage.setItem("income_value", incomeValue);
            // Do the same as above
            if (incomeExists !== 0) {
                setIncomeValue(incomeValue);
                updateMongoTotal(sessionStorage.getItem('userID'), 0, 'incomeTotal');

            } 
            // Likewise
            else {
                createMongoTotal(sessionStorage.getItem('userID'), 0);
                setIncomeExists(1);
                sessionStorage.setItem('incomeExists', 1);
            }    
            animateBar();
        }
    };

    //calculate tax off of the income value entered
    function calcTax(input_value = '') {
        /* Tax brackets is for single filers only in the US */
        let taxValue = 0;
        if (input_value > 0 && input_value <= 10275) {
            taxValue = 0.1;
        } else if (input_value > 10275 && input_value <= 41775) {
            taxValue = 0.12;
        } else if (input_value > 41775 && input_value <= 89075) {
            taxValue = 0.22;
        } else if (input_value > 89075 && input_value <= 170050) {
            taxValue = 0.24;
        } else if (input_value > 170050 && input_value <= 215950) {
            taxValue = 0.32;
        } else if (input_value > 215950 && input_value <= 539900) {
            taxValue = 0.35;
        } else if (input_value > 539900) {
            taxValue = 0.37;
        }

        return taxValue;
    }

    useEffect(() => {
        updateSession();
    }, []);
    
    // Adjust the text size based on how many digits exist
    function adjustTextSize(marginValue = '') {
        //Handles font size if income number gets too large
        let fontSize = 40; 
        let tmp = marginValue.toFixed(2).toString().length;
        if (tmp < 6) {
            fontSize = 40;
        } else if (tmp >= 6 && tmp < 8) {
            fontSize = 35;
        } else if (tmp >= 8 && tmp < 10) {
            fontSize = 30;
        } else if (tmp >= 10) {
            fontSize = 20;
        }
        return fontSize;
    }

    function animateBar() {
        let i_margin = incomeValue - (incomeValue * calcTax(incomeValue));
        setAfterTaxNum(i_margin);

        let progressValue = (progressValueRef || '').current;
        let circularProgress =  (circularProgressRef || '').current;
        let marginValue = i_margin - live_sum - give_sum - grow_sum - owe_sum;
    
        let fontSize = adjustTextSize(marginValue);
        (progressValue || '').style.fontSize = fontSize + "px";
    
        let progressStart = 0;
        let progressEnd = (marginValue / i_margin) * 100;
        let speed = 20;
    
        if (100 - progressEnd < 1 && 100 - progressEnd > 0) {
            progressEnd = 99;
        }
    
        let marginCount = marginValue - Math.trunc(progressEnd);
    
        // Check that the value isn negative
        if (marginValue <= 0) {
            progressStart = 0;
            progressValue.textContent = "$" + marginValue.toLocaleString('en-US', {'minimumFractionDigits':2,'maximumFractionDigits':2});
            (circularProgress || '').style.background = `conic-gradient(darkgoldenrod ${progressStart * 3.6}deg, #ededed 0deg)`;
        } 
        else {
            let progress = setInterval(() => {
                progressStart++;
                marginCount++;
        
                if (marginCount >= marginValue) {
                    marginCount = marginValue;
                }
                progressValue.textContent = '$' + marginCount.toLocaleString('en-US', {'minimumFractionDigits':2,'maximumFractionDigits':2});
                // Mulitply by 3.6 as it's 1% of a degree
                (circularProgress || '').style.background = `conic-gradient(darkgoldenrod ${progressStart * 3.6}deg, #ededed 0deg)`; 
        
                if (progressStart >= progressEnd) {
                    clearInterval(progress);
                }
            }, speed);
        }
    }

            
    var [chart, setChart] = useState(null);
    let [expenseTotal, setExpenseTotal] = useState(live_sum + give_sum + grow_sum + owe_sum);
    let chartSectionRef = useRef(null);
    let canvasRef = useRef(null);
    let chartErrorRef = useRef(null);
    let [chartDisplayed, setChartDisplayed] = useState(false);

    function formatData(data) {
        let newData = data / expenseTotal * 100;
        return newData.toFixed(1) + '%';
    }

    // Split text and join on commas
    function splitWithCommas(value) {
        if (value > 0) {
            value = value.toString();
            value = value.split(/(?=(?:...)*$)/);
            value = value.join(",");
            return value;
        } else {
            value = "";
            return value;
        }
    }

    // Only display labels for non-zero values
    function turnOffIfZero(context) {
        return context.dataset.data[context.dataIndex] > 0; 
    }

    let displayChart = () => {

        let yValues = [live_sum, give_sum, grow_sum, owe_sum];
        let xValues = ["Live", "Give", "Grow", "Owe"];

        let barColors = ["#b026ff","#00aba9","#2b5797","#009900"];
        let hoverColors = ["#c571f5","#00ccc9","#3f75c4","#00cc00"];

        let canvas = canvasRef.current;
        let chartError = chartErrorRef.current;

        let sum = yValues.reduce((a, b) => a + b, 0);

        if (sum === 0) {
            chartError.style.display = "block";
            canvas.style.display = "none";
        } else {
            chartError.style.display = "none";
            canvas.style.display = "block";

            let nonZeroIndexes = yValues.reduce((acc, val, idx) => {
                if (val > 0) {
                    acc.push(idx);
                }
                return acc;
            }, []);

            let nonZeroLabels = nonZeroIndexes.map(idx => xValues[idx]);
            let nonZeroData = nonZeroIndexes.map(idx => yValues[idx]);
            let nonZeroColors = nonZeroIndexes.map(idx => barColors[idx]);
            let nonZeroHoverColors = nonZeroIndexes.map(idx => hoverColors[idx]);
            
            if (chart) {
                chart.destroy();
            }

            chart = new Chart(canvas, {
                type: "pie",
                data: {
                    labels: nonZeroLabels,
                    datasets: [{
                        backgroundColor: nonZeroColors,
                        hoverBackgroundColor: nonZeroHoverColors,
                        data: nonZeroData,
                        datalabels: {color: '#fff', labels: null},
                        animation: {duration: 2000}
                    }]
                },
                options: {
                    plugins: {
                        datalabels: {
                            color: '#fff',
                            font: {size: 14},
                            display: turnOffIfZero,
                            formatter: formatData, splitWithCommas
                        }
                    },
                    animation: {animateRotate: true, animateScale: true,}
                }
            }); 

            setChart(chart);
        }
    }

    // Animate the spinning of the chart
    let animateChart = () => {        
        let canvas = (canvasRef || '').current;
        //let chartError = (chartErrorRef || '').current;
    
        if (chartDisplayed === false) {
            chartDisplayed = true;
            setChartDisplayed(chartDisplayed);
            canvas.style.opacity = 1;
            canvas.style.transition = "opacity 0.5s ease-in-out";
            displayChart();
        }
        
    }

    function useIsInViewPort(ref)
    {
        const [isIntersecting, setIsIntersecting] = useState(false);

        const observer = useMemo(
            () =>
                new IntersectionObserver(([entry]) => 
                setIsIntersecting(entry.isIntersecting),
                ),
            [],
        );

        useEffect(() => {
            observer.observe(ref.current);

            return () => {
                observer.disconnect();
            };

        }, [ref, observer]);
        
        return isIntersecting;
    }
    const isInViewPort = useIsInViewPort(chartSectionRef);

    useEffect(() => {
        if(isInViewPort === true) {
            animateChart();
        }else if (isInViewPort === false && chartDisplayed === true) {
            animateChart();
        }

    }, [isInViewPort])
                
    return (

        <>
            <link
                href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;600;700&display=swap"
                rel="stylesheet"
            />
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link
                rel="stylesheet"
                href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.min.css"
            />

            <section className='headersm'>
                <Navbar></Navbar>

                <div id="summary_head">
                    <h1>Income Summary</h1>
                </div>

                    <section className="progress-section" id="progress_bar">
                        <div className="progress-container">
                            <div className="circular-progress" ref={circularProgressRef}>
                                <span className="progress-value" id="progress_value" ref={progressValueRef}>$0</span>
                            </div>
                            <span className="income-text">Income Margin</span>

                            <label for="income_inputRef" class="visuallyhidden">income</label>
                            <input 
                            type="text" 
                            id="income_inputRef"
                            onChange={(event) => setIncomeValue(event.target.value)}
                            ref={income_inputRef} 
                            defaultValue={incomeValue !== '' ? "$" + parseFloat(incomeValue).toLocaleString('en-US', {'minimumFractionDigits':2,'maximumFractionDigits':2}) : incomeValue} 
                            onFocus={handleIncomeInputFocus} 
                            onKeyPress={handleCurrencyKeyPress} 
                            onBlur={handleIncomeFocusOut} 
                            onPaste={validateValue}
                            autoComplete="false"
                            placeholder="Enter monthly income" 
                            /> 

                            <div id="after_tax" ref={after_tax_divRef}>
                                <h1 id="after_tax_h1">Income After Tax: <span id="after_tax_num" >${afterTaxNum.toLocaleString('en-US', {'minimumFractionDigits':2,'maximumFractionDigits':2})}</span></h1>
                            </div>
                            <div id="total_expenses">
                                <h1 id="total_expenses_h1">Total Expenses: <span id="total_expenses_num"> ${(live_sum + give_sum + grow_sum + owe_sum).toLocaleString('en-US', {'minimumFractionDigits':2,'maximumFractionDigits':2})}</span></h1>
                            </div>
                        </div>
                    </section>

                    
                    <section className="finance-bar">
                        <div id="live_bar" className="shiny finance-num" ref={live_barRef}>
                            <h1>Live</h1>
                            <h2 ref={live_sumRef}>${live_sum.toLocaleString('en-US', {'minimumFractionDigits':2,'maximumFractionDigits':2})}</h2>
                        </div>
                    </section>

                    <section className="finance-bar">
                        <div id="give_bar" className="shiny finance-num" ref={give_barRef}>
                            <h1>Give</h1>
                            <h2 ref={give_sumRef}>${give_sum.toLocaleString('en-US', {'minimumFractionDigits':2,'maximumFractionDigits':2})}</h2>
                        </div>
                    </section>

                    <section className="finance-bar">
                        <div id="grow_bar" className="shiny finance-num" ref={grow_barRef}>
                            <h1>Grow</h1>
                            <h2 ref={grow_sumRef}>${grow_sum.toLocaleString('en-US', {'minimumFractionDigits':2,'maximumFractionDigits':2})}</h2>
                        </div>
                    </section>

                    <section className="finance-bar">
                        <div id="owe_bar" className="shiny finance-num" ref={owe_barRef}>
                            <h1>Owe</h1>    
                            <h2 ref={owe_sumRef}>${owe_sum.toLocaleString('en-US', {'minimumFractionDigits':2,'maximumFractionDigits':2})}</h2>    
                        </div>
                    </section>
                </section>
            
                <h1 className="pie-header1">Breakdown of Expenses</h1>
                <section className="alt-chart" id="chartSection" ref={chartSectionRef}>
                    <canvas style={{ width: '35%', maxWidth: '500px',height: '35%',maxHeight:'500px' }} ref={canvasRef} />
                    <div id="chartError" style= { {display: 'none'} } ref={chartErrorRef}>No data to display.</div>
                </section>
                
                <Footer></Footer>
        </>
    );
}

export default Summary